import { FC } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { TextInterpretation, ContainerActions } from './styled'

interface InterpretationButtonProps {
  betesa_result_id: number
  company_name: string
  user_name: string
  activeTab: string
}

const InterpretationButton: FC<InterpretationButtonProps> = ({
  betesa_result_id,
  company_name,
  activeTab,
}) => {
  const navigate = useNavigate()
  const destination = `/interpretation/detail?id=${betesa_result_id}&company=${company_name}&activeTab=${activeTab}`

  return (
    <ContainerActions>
      <Link
        to={destination}
        onPointerDown={(event) => {
          if (event.button !== 0) return
          event.preventDefault()
          navigate(destination)
        }}
      >
        <TextInterpretation>Interpretar</TextInterpretation>
      </Link>
    </ContainerActions>
  )
}

export default InterpretationButton
